<template>
	<section>
		<List
		:title="table.title"
		:breadcumb="table.breadcumb"
        :dataTable="table.dataTable">
			<template v-slot:button>
				<div>
					<button v-can="'jabatan/create'" type="button" class="btn btn-primary" data-toggle="modal" data-target="#Modal_TambahJabatan">
		                <i class="fa fa-plus fa-l" aria-hidden="true"></i> Tambah Jabatan
		            </button>

                    <button v-can="'jabatan/create'" type="button" class="btn btn-primary" style="margin-left: 4px;" data-toggle="modal" data-target="#Modal_Import">
                        <i class="fa fa-cloud-download fa-l" aria-hidden="true"></i> Import Jabatan
                    </button>
				</div>
			</template>

			<template v-slot:search>
				<div class="input-group form-search-rounded">
                    <input class="form-control py-2 border-right-0 border" v-model.lazy="search" type="search" id="example-search-input" placeholder="Cari jabatan disini..">
                    <span class="input-group-append">
                        <div class="input-group-text bg-transparent">
                            <a href="#" class="text-blue"><i class="fa fa-search"></i></a>
                        </div>
                    </span>
                </div>
			</template>

			<template v-slot:columnHeader>
				<thead>
                    <tr>
                        <th>No.</th>
                        <th @click="sortBy('name')">Nama 
                            <i class="fa sort" :class="currentSort == 'name' ? currentSortDir == 'asc' ? 'fa-sort-down' : currentSortDir == 'desc' ? 'fa-sort-up' : 'fa-sort' : 'fa-sort'"></i>
                        </th>
                        <th @click="sortBy('type_text')">Role 
                            <i class="fa sort" :class="currentSort == 'type_text' ? currentSortDir == 'asc' ? 'fa-sort-down' : currentSortDir == 'desc' ? 'fa-sort-up' : 'fa-sort' : 'fa-sort'"></i>
                        <th @click="sortBy('unit_text')">Unit 
                            <i class="fa sort" :class="currentSort == 'unit_text' ? currentSortDir == 'asc' ? 'fa-sort-down' : currentSortDir == 'desc' ? 'fa-sort-up' : 'fa-sort' : 'fa-sort'"></i>
                        </th>
                        <th @click="sortBy('bidang_text')">Bidang 
                            <i class="fa sort" :class="currentSort == 'bidang_text' ? currentSortDir == 'asc' ? 'fa-sort-down' : currentSortDir == 'desc' ? 'fa-sort-up' : 'fa-sort' : 'fa-sort'"></i>
                        </th>
                        <th @click="sortBy('subbidang_text')">Sub Bidang 
                            <i class="fa sort" :class="currentSort == 'subbidang_text' ? currentSortDir == 'asc' ? 'fa-sort-down' : currentSortDir == 'desc' ? 'fa-sort-up' : 'fa-sort' : 'fa-sort'"></i>
                        </th>
                        <th @click="sortBy('status')">Status
                            <i class="fa sort" :class="currentSort == 'status' ? currentSortDir == 'asc' ? 'fa-sort-down' : currentSortDir == 'desc' ? 'fa-sort-up' : 'fa-sort' : 'fa-sort'"></i>
                        </th>
                        <th width="10%">Aksi</th>
                    </tr>
                </thead>
			</template>

			<template v-slot:action="{ data }">
                <div class="btn-action-block">
                    <button v-can="'jabatan/detail'"  type="button" data-toggle="modal" data-target="#Modal_JabatanData" @click="detail = data" class="btn btn-icon-small btn-success-trans waves-effect waves-light">
                        <i class="fa fa-eye"></i>
                    </button>
                    <router-link v-can="'jabatan/update'"  :to="'jabatan/edit/' + data.id" type="button" class="btn btn-icon-small btn-warning-trans waves-effect waves-light" style="margin-left: 2px;">
                        <i class="fa fa-pencil"></i>
                    </router-link>
                    <button v-can="'jabatan/delete'"  type="button" @click="destroy(data)" class="btn btn-icon-small btn-danger-trans waves-effect waves-light" id="confirm-text" style="margin-left: 2px;">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>
            </template>
		</List>

        <!-- Modal -->
        <div class="modal fade text-left" id="Modal_TambahJabatan" tabindex="-1" role="dialog" aria-labelledby="myModalLabel160" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header modal-primary white">
                        <h5 class="modal-title" id="myModalLabel160">Tambah Jabatan</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <ValidationObserver v-slot="{ invalid }" ref="observer">
                        <div class="modal-body">
                            <ValidationProvider name="Nama" v-slot="{ errors }" rules="required">
                                <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                    <label for="">Nama Jabatan</label>
                                    <input type="text" v-model="model.name" class="form-control" placeholder="Masukan nama jabatan" aria-describedby="helpId" required="">
                                </div>
                            </ValidationProvider>

                            <ValidationProvider name="Role" v-slot="{ errors }" rules="required">
                                <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                    <label for="">Role</label>
                                    <select v-model="model.type" class="custom-select form-control">
                                        <option value="" selected>Pilih Role</option>
                                        <option value="1">Pengawas</option>
                                        <option value="2">Non Pengawas</option>
                                    </select>
                                </div>
                            </ValidationProvider>

                            <ValidationProvider name="Unit" v-slot="{ errors }" rules="required">
                                <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                    <label for="">Unit</label>
                                    <select v-model="model.unit" class="custom-select form-control">
                                        <option value="" selected>Pilih Unit</option>
                                        <option value="1">UIP</option>
                                        <option value="2">UPP</option>
                                    </select>
                                </div>
                            </ValidationProvider>
                            
                            <ValidationProvider name="Bidang" v-slot="{ errors }" rules="">
                                <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                    <label for="">Bidang</label>
                                    <select v-model="model.id_bidang" class="form-control" :disabled="model.unit == ''">
                                        <option value="" selected>Pilih Bidang</option>
                                        <option :value="bid.id" v-for="(bid, ix) in bidang.filter(x => x.unit == model.unit)" :key="ix">{{ bid.name }}</option>
                                    </select>
                                </div>
                            </ValidationProvider>

                            <ValidationProvider v-if="model.unit == 1" name="Sub Bidang" v-slot="{ errors }" rules="">
                                <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                    <label for="">Sub Bidang</label>
                                    <select v-model="model.id_subbidang" class="form-control" :disabled="model.unit == ''">
                                        <option value="">Pilih Sub Bidang</option>
                                        <option :value="subbid.id" v-for="(subbid, ix) in subbidang.filter(x => x.unit == model.unit)" :key="ix">{{ subbid.name }}</option>
                                    </select>
                                </div>
                            </ValidationProvider>

                            <div v-if="model.type == 1">
                                <ValidationProvider name="Atasan" v-slot="{ errors }" rules="">
                                    <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                        <label for="">Atasan</label>
                                        <select v-if="model.unit == 1" v-model="model.index" class="form-control" :disabled="model.type == ''">
                                            <option value="">Pilih Atasan</option>
                                            <option :value="pos.id" v-for="(pos, ix) in 
                                                position" :key="ix">{{ pos.name }} - {{ pos.bidang_text }} - {{ pos.subbidang_text }}
                                            </option>
                                        </select>
                                        <select v-else-if="model.unit == 2" v-model="model.index" class="form-control" :disabled="model.type == ''">
                                            <option value="">Pilih Atasan</option>
                                            <option :value="pos.id" v-for="(pos, ix) in 
                                                position" :key="ix">{{ pos.name }} - {{ pos.bidang_text }} - {{ pos.subbidang_text }}
                                            </option>
                                        </select>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div v-else-if="model.type == 2">
                                <ValidationProvider name="Atasan" v-slot="{ errors }" rules="">
                                    <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                        <label for="">Atasan</label>
                                        <select v-if="model.unit == 1" v-model="model.index" class="form-control" :disabled="model.type == ''">
                                            <option value="">Pilih Atasan</option>
                                            <option :value="pos.id" v-for="(pos, ix) in 
                                                position" :key="ix">{{ pos.name }} - {{ pos.bidang_text }} - {{ pos.subbidang_text }}
                                            </option>
                                        </select>
                                        <select v-else-if="model.unit == 2" v-model="model.index" class="form-control" :disabled="model.type == ''">
                                            <option value="">Pilih Atasan</option>
                                            <option :value="pos.id" v-for="(pos, ix) in 
                                                position" :key="ix">{{ pos.name }} - {{ pos.bidang_text }} - {{ pos.subbidang_text }}
                                            </option>
                                        </select>
                                    </div>
                                </ValidationProvider>
                            </div>

                            <ValidationProvider name="model.status" v-slot="{ errors }" rules="required">
                                <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                    <label for="">Status</label>
                                    <div class="custom-control custom-switch custom-control-inline mt-1">
                                        <input type="checkbox" v-model="model.status" class="custom-control-input" id="customSwitch1">
                                        <label class="custom-control-label" for="customSwitch1">
                                        </label>
                                        <span class="switch-label">{{ model.status ? 'Aktif' : 'Tidak Aktif' }}</span>
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Tutup</button>
                            <button type="button" :disabled="invalid" @click="save()" class="btn btn-primary" data-dismiss="modal">Tambah Jabatan</button>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
        <ModalDetail v-if="detail != null" :detail="detail"/>
        <ModalImport
            title="Jabatan"
            url="position"
            @success="getList()"/>
	</section>
</template>

<script>
import List from '@/components/List.vue'
import ModalDetail from './ModalDetail.vue'
import ModalImport from '@/components/ModalImport.vue'

export default {
	name: 'JabatanIndex',
	components: {
		List,
        ModalDetail,
        ModalImport
	},
	data() {
		return {
			table: {
				title: "Jabatan",
				breadcumb: "Master Data",
                dataTable: {
                    lists: [],
                    columns: ['name', 'type_text', 'unit_text', 'bidang_text', 'subbidang_text', 'status_text']
                }
			},
            position: [],
            search: null,
            detail: [],
            model: {
                status: false,
                type: '',
                index: '',
                unit: '',
                id_bidang: '',
                id_subbidang: ''
            },
            currentSort: 'id',
            currentSortDir: 'desc',
            bidang: [],
            subbidang: []
		}
	},
    mounted() {
        let _ = this
        _.getList()
        _.all()
        _.$root.$on("paginate", (data) => {
            _.getList(data)
        });
        _.get_bidang()
        _.get_subbidang()
    },
    beforeDestroy(){
        this.$root.$off("paginate");
    },
    methods: {
        getList(page) {
            let _ = this
            _.axios.get('/position?key=' + _.search + '&page=' + page + '&orderby=' + _.currentSort + '&sort=' + _.currentSortDir)
                .then(resp=>{
                    _.table.dataTable.lists = resp.data.data.rows
                })
                .catch(err=>{
                    console.log(err.response)
                })
        },
        save() {
            let _ = this
            _.axios.post('/position', _.model)
                .then(resp => {
                    if (resp.status) {
                        _.getList()
                        _.all()
                        _.$toast.success('Data Berhasil Disimpan')
                    }else{
                        console.log("Failed")
                        _.$toast.warning('Data Gagal Disimpan')
                    }
                    _.model = {
                        status: false,
                        name: null
                    }
                    _.$refs.observer.reset();
                })
                .catch(err=>{
                    console.log(err.response)
                    _.model = {
                        status: false,
                        name: null
                    }
                    _.$refs.observer.reset();
                    _.$toast.warning('Data Jabatan Sudah Digunakan')
                })
        },
        destroy(x) {
            let _ = this
            if ( parseInt(x.users_count) == 0 ) {
                this.$swal.fire({
                    title: 'Hapus Data Ini?',
                    text: "Anda mungkin tidak akan mengembalikannya lagi!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#44A8BD',
                    cancelButtonColor: '#D95E6A',
                    confirmButtonText: 'Ya, Hapus!',
                    cancelButtonText: 'Batal'
                    }).then((result) => {
                        if (result.value) {
                            _.axios.delete('/position', { data: { id: x.id }})
                                .then(resp => {
                                    if (resp.status) {
                                        _.getList()
                                        _.all()
                                        this.$swal.fire({
                                            title: 'Terhapus!',
                                            text: "Data berhasil dihapus",
                                            icon: 'success',
                                            confirmButtonColor: '#37BA71',
                                            confirmButtonText: 'OK'
                                        })
                                    }else{
                                        console.log("Failed")
                                    }
                                })
                                .catch(err=>{
                                    console.log(err.response)
                                })                        
                        }
                })
            } else {
                this.$swal.fire({
                    title: 'Tidak Dapat Menghapus',
                    text: "Data tidak dapat dihapus karena dipakai oleh data lain",
                    icon: 'warning',
                    cancelButtonColor: '#D95E6A',
                    cancelButtonText: 'OK'
                    })
            }
        },
        sortBy(x) {
            if (x === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSortDir = 'asc'
            }
            this.currentSort = x;
            this.getList()
        },
        all() {
            let _ = this
            _.axios.get('/position/all')
                .then(resp=>{
                    _.position = resp.data.data
                })
                .catch(err=>{
                    console.log(err.response)
                })
        },
        get_bidang() {
            let _ = this
            _.axios.get('/bidang/all')
                .then(resp=>{
                    _.bidang = resp.data.data
                })
                .catch(err=>{
                    console.log(err.response)
                })
        },
        get_subbidang() {
            let _ = this
            _.axios.get('/subbidang/all')
                .then(resp=>{
                    _.subbidang = resp.data.data
                })
                .catch(err=>{
                    console.log(err.response)
                })
        }
    },
    watch: {
        search: function() {
            this.getList()
        },
        'model.unit': function(newValue, oldValue) {
            if (oldValue != null){
                this.model.id_bidang = ''
                this.model.id_subbidang = ''
                this.model.index = ''
            }            
        },
        'model.bidang': function(newValue, oldValue) {
            if (oldValue != null){
                this.model.index = ''
            }            
        },
        'model.subbidang': function(newValue, oldValue) {
            if (oldValue != null){
                this.model.index = ''
            }            
        }    
    }
}
</script>